var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#397k1v1t0a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667.563v5.541L2.12 3.81A10.13 10.13 0 0 1 6.667.563zM17.879 3.81l-4.33 2.294V.563a10.39 10.39 0 0 1 4.33 3.247zM6.667 13.896v5.542a9.914 9.914 0 0 1-4.33-3.29l4.33-2.252zM17.879 16.148a10.13 10.13 0 0 1-4.33 3.29v-5.541l4.33 2.25z",
    fill: "#04247B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.51 13.556 2.065 1.053c-.234.42-.491.826-.772 1.217l-4.138-2.152-.365-.19v5.76l-1.136.293a9.75 9.75 0 0 1-1.923-.002l-.025-.003-.024.003a9.748 9.748 0 0 1-1.923.002l-1.136-.293V13.485l-.365.19-4.202 2.184-.326-.206 4.192-2.096-.112-.473H3.275l-.052.025-2.067 1.014a9.492 9.492 0 0 1-.692-2.167 9.75 9.75 0 0 1 .001-1.93l.001-.012v-.012a9.75 9.75 0 0 1 .211-1.941l.001-.004c.076-.384.171-.765.285-1.14h2.37l.11-.475-2.06-1.01c.248-.449.521-.884.817-1.303l4.354 2.198.363.183V.757L8.052.464a9.75 9.75 0 0 1 1.923.001l.012.002h.011c.65.005 1.3.075 1.936.21l1.15.296V6.52l.366-.195L17.63 4.11l.19.163L13.525 6.4l.111.474h3.09l.053-.027 2.027-1.014c.336.693.582 1.426.732 2.181v.003c.139.653.21 1.317.212 1.984H20l-.249.024c.064.642.065 1.288.001 1.93-.075.38-.17.757-.282 1.129h-2.847l-.113.472z",
    fill: "#fff",
    stroke: "#F2F2F2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 6.667H.563c.132-.386.291-.762.476-1.126l2.294 1.126zM19.437 13.334c0 .39-.303.779-.52 1.168l-2.294-1.168h2.814zM18.918 5.541l-2.252 1.126h-3.03l4.632-2.338c.27.373.49.78.65 1.212zM6.32 13.334l-4.588 2.294c-.26-.39-.477-.78-.693-1.169l2.294-1.125H6.32z",
    fill: "#CE152A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10c.066.662.066 1.33 0 1.992h-8.009v7.792c-.662.066-1.329.066-1.991 0-.662.066-1.33.066-1.991 0v-7.792H.216a10 10 0 0 1 0-1.992A10 10 0 0 1 .433 8.01h7.792V.217a10 10 0 0 1 1.991 0 10 10 0 0 1 1.992.216v7.792H20c.053.59.053 1.185 0 1.775z",
    fill: "#CE152A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "397k1v1t0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK-Flag.0aa7d4adeecd3daea0ef86bd632b9a5f.svg";
export { ForwardRef as ReactComponent };